import React , {Component} from 'react';
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import backIcon from './../assets/images/icons/back-2.svg';
import forwardIcon from './../assets/images/icons/forward.svg';
import descriptionIcon from './../assets/images/icons/description.svg';
import ProductCard from "./section/ProductInCartCard";
import * as axios from "axios/index";
import * as vars from './Vars';
import LoginRegister from "./section/LoginRegister";
import NumberFormat from 'react-number-format';
import { Modal } from 'react-bootstrap';

class CartV4 extends Component{


    constructor(props){

        super(props)
        this.state = {
            branchSlug : "",
            totalPayablePrice: 0 ,
            totalDiscountPrice: 0 ,
            userIsLogin : !(localStorage.getItem('api_token') === null || localStorage.getItem('api_token') === undefined || localStorage.getItem('api_token') === "undefined") ,
            loginModalShow : false ,
            descriptionModal : false ,

            errors : {} ,
            fields : {
                description : !(localStorage.getItem('description') === null || localStorage.getItem('description') === undefined || localStorage.getItem('description') === "undefined") ? localStorage.getItem('description') : "",
            } ,
            description : !(localStorage.getItem('description') === null || localStorage.getItem('description') === undefined || localStorage.getItem('description') === "undefined") ? localStorage.getItem('description') : null,


            removedProductModalShow : false ,
            removedProduct : [] ,
            updatedProductsQtyModalShow : false ,
            updatedProductsQty : [] ,
        }


    }

    componentDidMount(){
        this.cartHandler()
    }

    cartHandler(){

        const products = []
       /* this.props.cart.map((object , index) => {
            products.push({
                code : this.props.products[index].code ,
                qty : object
            })
        })*/
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];

            products.push({
                code: product.code,
                qty: qty
            });
        });


        let data = new FormData()
        data.append('api_token' , localStorage.getItem('api_token') )
        data.append('products' , JSON.stringify(products) )
        data.append('delivery_time' , localStorage.getItem('orderDeliveryTimeKey'))
        data.append('delivery_date' , localStorage.getItem('orderDeliveryDateValue'))
        let branchSlug = localStorage.getItem("branchSlug")
        this.setState({
            branchSlug : branchSlug
        })
        axios.post(vars.Url +'api/v4/order/check/' + branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                if (data.cart.removedProducts !== undefined  && data.cart.removedProducts.length > 0)
                {
                    this.setState({
                        removedProduct : data.cart.removedProducts ,
                        removedProductModalShow : true ,
                    })
                    data.cart.removedProducts.map((object,index) => {
                        delete this.props.cart[object.id];
                    })
                }

                if (data.cart.updatedProductsQty !== undefined  && data.cart.updatedProductsQty.length > 0)
                {
                    this.setState({
                        updatedProductsQty : data.cart.updatedProductsQty ,
                        updatedProductsQtyModalShow : true ,
                    })
                    data.cart.updatedProductsQty.map((object,index) => {
                        //console.log(object.qty)
                        this.props.cart[object.id] = object.qty
                        this.props.products[object.id] = {
                            ...this.props.products[object.id],
                            daily_stock_count: object.daily_stock_count
                        }
                    })
                }

                this.setState({
                    totalPayablePrice : data.cart.totalPayablePrice ,
                    totalDiscountPrice : data.cart.totalDiscountPrice ,
                })
                localStorage.setItem("totalPayablePrice" , data.cart.totalPayablePrice)
            })
            .catch(error => {
                // console.log(error)
            })

    }

    removedProductModalShowHandler(){
        this.setState({
            removedProductModalShow : false ,
            submitErrorMessage : ''
        })
    }



    updatedProductsQtyModalShowHandler(){
        this.setState({
            updatedProductsQtyModalShow : false ,
            submitErrorMessage : ''
        })
    }

    loginModalShowHandler(){
        this.setState({
            loginModalShow : !this.state.loginModalShow
        })
    }

    userIsLoginHandler(){
        this.setState({
            userIsLogin : true
        })
    }

    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    descriptionModalHideHandler(){
        this.setState({
            descriptionModal : false
        })
    }
    descriptionModalSubmitHandler(){
        localStorage.setItem("description" , this.state.fields.description)
        this.setState({
            descriptionModal : false ,
            description : this.state.fields.description ,
        })
    }


    render(){
        const { products } = this.props
        const { errors } = this.state
        return(
            <div id="main-custom-1" className="text-decoration-none">

                <Modal
                    show={this.state.removedProductModalShow}
                    onHide={this.removedProductModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        متاسفانه محصولات زیر به دلیل ناموجود شدن، از سبد خرید شما حذف شد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.removedProduct.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.removedProductModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>


                <Modal
                    show={this.state.updatedProductsQtyModalShow}
                    onHide={this.updatedProductsQtyModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        تعداد محصولات زیر در سبد شما تغییر کرد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.updatedProductsQty.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                    حداکثر تعداد قابل خرید:
                                    {object.daily_stock_count}
                                    عدد
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.updatedProductsQtyModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>



                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to={"/branch/" + this.state.branchSlug + "/product"}>
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>

                                            <span className="title">
                                                سبد خرید
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>



                <div className="container p-0">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">


                            {
                                Object.keys(this.props.cart).length > 0 ?
                                    (
                                        <div>
                                            <div className="row no-gutters">
                                                <div className="col">
                                                    <div className="items-container items-container-custom-1 has-fixed-footer-1">
                                                        {/*{this.props.cart.map((object , index) =>
                                                            <ProductCard
                                                                key={index}
                                                                product={products[index]}
                                                                cartHandler={this.cartHandler.bind(this)}
                                                            />
                                                        )}*/}

                                                        {Object.keys(this.props.cart).map((productId) => {
                                                            const qty = this.props.cart[productId];
                                                            const product = this.props.products[productId];

                                                            return (
                                                                <ProductCard
                                                                    key={productId}
                                                                    product={product}
                                                                    qty={qty} // اگر لازم داری تو ProductCard نشون بدی
                                                                    cartHandler={this.cartHandler.bind(this)}
                                                                />
                                                            )
                                                        })}

                                                        {
                                                            this.state.description === null ?
                                                                (
                                                                    <div className="row no-gutters justify-content-end">
                                                                        <div className="col-auto">
                                                                            <div className="card-custom-12" onClick={() => this.setState({descriptionModal : true})}>
                                                                                <img src={descriptionIcon} alt="description" className="item-icon" />
                                                                                افزودن توضیح به سفارش
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                                :
                                                                (
                                                                    <div className="row no-gutters">
                                                                        <div className="col">
                                                                            <div className="card-custom-13" onClick={() => this.setState({descriptionModal : true})}>
                                                                                <div className="row no-gutters">
                                                                                    <div className="col-auto pl-2">
                                                                                        <img src={descriptionIcon} alt="description" className="item-icon" />
                                                                                    </div>
                                                                                    <div className="col">
                                                                                        <div>
                                                                                            {this.state.description}
                                                                                        </div>


                                                                                        <div className="sub-title mt-3">
                                                                                            ویرایش
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                        }



                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )
                                    :
                                    (
                                        <div className="row no-gutters justify-content-center">
                                            <div className="col-auto">
                                                <div className="card-custom-14">
                                                    <div className="content-container">
                                                        <div className="title">
                                                            سبد خالیست!
                                                        </div>
                                                        <div className="sub-title">
                                                            محصولی به سبد اضافه کنید
                                                        </div>
                                                        <Link to={"/branch/" + this.state.branchSlug + "/product"} className="btn btn-custom-2">
                                                            لیست محصولات
                                                        </Link>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    )
                            }








                        </div>
                    </div>


                </div>

                {
                    Object.keys(this.props.cart).length > 0 ?
                        (
                            <footer id="footer-2" className="text-decoration-none">
                                <div className="container p-0">
                                    <div className="row no-gutters justify-content-center">
                                        <div className="col-lg-6">
                                            <div className="items-container">
                                                <div className="row justify-content-between align-items-center">
                                                    <div className="col-auto">
                                                        <div className="price">
                                                            <div className="title">
                                                                جمع کل
                                                            </div>
                                                            <div className="value">
                                                                <NumberFormat value={this.state.totalPayablePrice} displayType={'text'} thousandSeparator={true}  />
                                                                <span className="currency">
                                                        تومان
                                                    </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="discount-price">
                                                            <div className="title">
                                                                جمع تخفیف
                                                            </div>
                                                            <div className="value">
                                                                <NumberFormat value={this.state.totalDiscountPrice} displayType={'text'} thousandSeparator={true}  />
                                                                <span className="currency">
                                                        تومان
                                                    </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mt-5">
                                                    <div className="col">
                                                        { this.state.userIsLogin === true ?
                                                            (
                                                                <Link to="/address" className="btn btn-custom-5 btn-block">
                                                                    ادامه  (آدرس و شیوه تحویل)
                                                                    <img src={forwardIcon} alt="forward" className="item-icon" />
                                                                </Link>
                                                            )
                                                            :
                                                            (
                                                                <div className="btn btn-custom-5 btn-block" onClick={this.loginModalShowHandler.bind(this)}>
                                                                    ادامه  (آدرس و شیوه تحویل)
                                                                    <img src={forwardIcon} alt="forward" className="item-icon" />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        )
                        :
                        (``)
                }


                <Modal
                    show={this.state.descriptionModal}
                    onHide={this.descriptionModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            افزودن توضیح به سفارش
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                                 <textarea
                                     placeholder="افزودن توضیح به سفارش"
                                     name="description"
                                     className={["form-control form-control-custom-1" , errors['description'] ? 'is-invalid' : ''].join(' ')}
                                     onChange={this.handleChange.bind(this)}
                                     value={this.state.fields.description}
                                     rows={3}
                                 ></textarea>
                                <span className={["invalid-feedback" ,  errors['description'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['description'] }</span>
                                <img src={descriptionIcon} alt="description" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-7" onClick={this.descriptionModalSubmitHandler.bind(this)}>
                                افزودن
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>


                <LoginRegister userIsLoginHandler={this.userIsLoginHandler.bind(this)} loginModalShow={this.state.loginModalShow} loginModalShowHandler={this.loginModalShowHandler.bind(this)} />


            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = state => {
    return {
        cart : state.cart ,
        products : state.products ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(CartV4);